module.exports = __webpack_public_path__ + "img/ls_logo_footer.a8373aa2.png";